import * as React from "react";
import { forwardRef } from "react";
const SvgHamburger = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 19 15", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 1.5H17.5M1 7.5H17.5M1 13.5H17.5", stroke: "#626262", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgHamburger);
export default ForwardRef;
